export default class DeleteContactLocationRequest  {
	contactId: string;
	contactLocationId: string;
}